'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var format = require('./format.js');

/**
 * Get localized date and time (without seconds)
 * @example localizeDateTime(2020-10-15T19:51:45.291Z) => 10/15/2020, 3:51 PM
 * @param dateTime Date | string
 * @param locale string | string[]
 * @param options Intl.DateTimeFormatOptions | undefined
 * @returns string
 */ const localizeDateTime = (dateTime, locale, options)=>{
    const locales = [
        navigator.language
    ];
    if (locale) {
        if (Array.isArray(locale)) {
            for (const l of locale)locales.unshift(l);
        } else {
            locales.unshift(locale);
        }
    }
    return format.formatDateTime(dateTime, locales, options || {
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        month: 'numeric',
        year: 'numeric'
    });
};

exports.localizeDateTime = localizeDateTime;
//# sourceMappingURL=date-time.js.map
